import './NoEntriesMatching.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';

export const NoEntriesMatching = () => {
  const { t } = useTranslation();
  return (
    <div className='no-entries-matching'>
      <h2>{t('NoMatchingResults', { ns: 'organizationPage' })}</h2>
      <Paragraph>{t('TryDifferentFilters', { ns: 'organizationPage' })}</Paragraph>
    </div>
  );
};
